import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import { BasicFooter, BasicHeader } from 'components';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1200 + (theme.spacing.unit * 3 * 2))]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  mainContent: { margin: '0 auto', padding: 10, paddingTop: theme.spacing.unit * 15 },
});

class Features extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.shape({}).isRequired,
  };

  componentDidMount() {
    document.body.classList.add('body-home');
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.body.classList.remove('body-home');
  }

  render(){
    const {
      children,
      classes
    } = this.props;

    return(
      <div className="home-page">
      <BasicHeader />
      <main className={classNames(classes.layout, classes.mainContent)}>
        {children}
      </main>
      <BasicFooter />
    </div>
    )
  }
}

export default compose(
  setDisplayName('Features'),
  withStyles(styles),
)(Features);
